"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingHelper = exports.losslessJsonCustomNumberParser = void 0;
const ethers_1 = require("ethers");
const staking_json_1 = __importDefault(require("./abi/staking.json"));
const graphql = __importStar(require("./graphql"));
const debug_1 = __importDefault(require("debug"));
const config_1 = __importDefault(require("./config"));
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const lossless_json_1 = __importDefault(require("lossless-json"));
// parse integer values into a BigNumber, and use a regular number otherwise
function losslessJsonCustomNumberParser(value) {
    return lossless_json_1.default.isInteger(value)
        ? ethers_1.BigNumber.from(value)
        : parseFloat(value);
}
exports.losslessJsonCustomNumberParser = losslessJsonCustomNumberParser;
const losslessJsonParse = (text) => {
    return lossless_json_1.default.parse(text, undefined, losslessJsonCustomNumberParser);
};
const debug = (0, debug_1.default)("staking");
const ether = ethers_1.ethers.utils.parseEther("1");
function sumBigNumbers(amounts) {
    return amounts.reduce((sum, amt) => sum.add(amt), ethers_1.BigNumber.from(0));
}
function sumAttributeBigNumbers(objs, attributeName) {
    return sumBigNumbers(objs.map((obj) => obj[attributeName]));
}
function bigNumberToInt(n) {
    return BigInt(n.toString());
}
class StakingHelper {
    // sessionBlocks: Number(process.env.SESSION_BLOCKS) || 10800,
    // sessionInYear: 365 * 8,
    // rpc: process.env.RPC || "https://mainnet-rpc.thundercore.com",
    // network: Number(process.env.NETWORK) || 108,
    // stakingContract: process.env.STAKING_CONTRACT || "",
    // graphUri: process.env.GRAPH_URI || "",
    constructor({ rpc, network, stakingAddress, stopBlockSessionOffset, blockTime, pos2SubgraphUrl, blockscoutApiUrl, }) {
        this.rpc = rpc || config_1.default.rpc;
        this.network = network || config_1.default.network;
        // stakingAddress is used in this.staking below
        this.stopBlockSessionOffset = stopBlockSessionOffset;
        this.pos2SubgraphUrl = pos2SubgraphUrl;
        this.blockTime = blockTime;
        this.blockscoutApiUrl = blockscoutApiUrl;
        this.provider = new ethers_1.ethers.providers.JsonRpcProvider(this.rpc, this.network);
        this.staking = new ethers_1.ethers.Contract(stakingAddress, staking_json_1.default, this.provider);
    }
    async getTotalStakingScore(blockNumber) {
        return await this.staking.getTotalStakingScore({ blockTag: blockNumber });
    }
    async getSession() {
        const session = (await this.staking.getSession());
        return session.toNumber();
    }
    async getBlockEventAmounts(event, blockNumber) {
        // scott: using the same blockNumber as start and end block in queryFilter seems suspect
        const events = (await this.staking.queryFilter(event, blockNumber, blockNumber));
        // @ts-ignore
        const amounts = events.map((e) => e.args.amount);
        // const amounts = events.map((e) => e.args.blockNumber);
        return sumBigNumbers(amounts);
    }
    async getManuallyAddedRewards(session) {
        // {
        //   "rewardAdds": [
        //     {
        //       "ttAmount": "10000000000000000000000000"
        //     },
        //     {
        //       "ttAmount": "10000000000000000000000000"
        //     },
        //     {
        //       "ttAmount": "10000000000000000000000000"
        //     },
        //     {
        //       "ttAmount": "10000000000000000000000000"
        //     }
        //   ]
        // }
        let rewardAdds;
        try {
            const queryResult = await this.queryRewardAddsBySession(session);
            rewardAdds = sumAttributeBigNumbers(queryResult["rewardAdds"], "ttAmount");
        }
        catch (e) {
            console.error("queryManuallyAddedRewards: error", e);
            rewardAdds = ethers_1.BigNumber.from(0);
        }
        return rewardAdds;
    }
    async getLastRewardFromSessionDiff({ lastBalance, currentBalance, stakes, withdraws, sessionStartBlock, }) {
        const stakesInSession = sumBigNumbers(stakes);
        const withdrawsInSession = sumBigNumbers(withdraws);
        let reward = currentBalance
            .sub(lastBalance)
            .sub(stakesInSession)
            .add(withdrawsInSession);
        debug("sessionStartBlock:", sessionStartBlock);
        debug("stakesInSession", ethers_1.ethers.utils.formatEther(stakesInSession));
        debug("withdrawsInSession", ethers_1.ethers.utils.formatEther(withdrawsInSession));
        debug("currentBalance", ethers_1.ethers.utils.formatEther(currentBalance));
        debug("lastBalance", ethers_1.ethers.utils.formatEther(lastBalance));
        debug("reward:", ethers_1.ethers.utils.formatEther(reward));
        // NOTE: used to contain code that attempt to handle `Enter` and `Leave` in block of currentBalance
        return reward;
    }
    async getBlock(block) {
        return await this.provider.getBlock(block);
    }
    static async getSNByBlock(blockNumber, rpc) {
        try {
            const data = {
                jsonrpc: "2.0",
                method: "thunder_getBlockSnByNumber",
                params: [blockNumber],
                id: 0,
            };
            const res = await (0, cross_fetch_1.default)(rpc || config_1.default.rpc, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            const resJson = (await res.json());
            const sn = resJson.result.slice(1, resJson.result.indexOf(","));
            return Number(sn);
        }
        catch (error) {
            throw new Error("Failed to get block SN: " + error);
        }
    }
    static async getRewardInfo(stopBlockNumber, rpc) {
        const data = {
            jsonrpc: "2.0",
            method: "thunder_getRewardInfo",
            params: [`0x${stopBlockNumber.toString(16)}`],
            id: 0,
        };
        const res = await (0, cross_fetch_1.default)(rpc, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        // NOTE: "Fee" are big numbers but returned using number syntax in the API JSON response
        const jsonText = await res.text();
        const response = losslessJsonParse(jsonText);
        if (response["error"]) {
            if (response["error"]["message"]) {
                throw new Error(response["error"]["message"]);
            }
            else {
                throw new Error(JSON.stringify(response["error"]));
            }
        }
        if (response["result"]) {
            return response["result"];
        }
        throw new Error(`no "result" key in ${JSON.stringify(response)}`);
        // {
        //   "jsonrpc": "2.0",
        //   "id": 1,
        //   "result": {
        //     "Payments": [
        //       {
        //         "Coinbase": "0x60a11097d76afa40fa50aeadf17c47076dd2dbb6",
        //         "Fee": 1665489390600000000000
        //       },
        //       {
        //         "Coinbase": "0x60a11097d76afa40fa50aeadf17c47076dd2dbb6",
        //         "Fee": 1665489390600000000000
        //       },
        //       {
        //         "Coinbase": "0x60a11097d76afa40fa50aeadf17c47076dd2dbb6",
        //         "Fee": 1665489390600000000000
        //       },
        //       {
        //         "Coinbase": "0x9009a7e2fd59f94ba50c631e0094067362755997",
        //         "Fee": 277581565100000000000
        //       },
        //       {
        //         "Coinbase": "0x9009a7e2fd59f94ba50c631e0094067362755997",
        //         "Fee": 277581565100000000000
        //       },
        //       {
        //         "Coinbase": "0x0000000000000000000000000000001234567989",
        //         "Fee": 0
        //       }
        //     ]
        //   }
        // }
        // {
        //   "jsonrpc": "2.0",
        //   "id": 1,
        //   "error": {
        //     "code": -32000,
        //     "message": "Block number 10800 is not stop block"
        //   }
        // }
    }
    static async getConsensusRewards(stopBlockNumber, rpc, posContractAddr) {
        const rewardInfo = await this.getRewardInfo(stopBlockNumber, rpc);
        const payments = rewardInfo["Payments"];
        if (!payments) {
            throw new Error(`No "Payments" key in ${JSON.stringify(rewardInfo)}`);
        }
        let sum = ethers_1.BigNumber.from(0);
        for (const r of payments) {
            // Compare canonical address: https://docs.ethers.org/v5/single-page/#/v5/api/utils/address/
            if (r["Coinbase"] &&
                ethers_1.ethers.utils.getAddress(r["Coinbase"]) ===
                    ethers_1.ethers.utils.getAddress(posContractAddr)) {
                sum = sum.add(r["Fee"]);
            }
        }
        return sum;
    }
    static async graphqlQuery(uri, q, variables) {
        const res = await graphql.query(uri, q, variables);
        if (res.errors) {
            console.log("res.errors:", res.errors);
            throw new Error(res.errors[0].message);
        }
        return res.data;
    }
    static async getLastSessionAmts(graphUri, event, session) {
        const q = `{
      ${event}(first: 1000, where: {session: ${session - 1}}) {
        amount
      }
    }`;
        const res = await graphql.query(graphUri, q, {});
        if (res.errors) {
            console.log("res.errors:", res.errors);
            throw new Error(res.errors[0].message);
        }
        return res.data && res.data[event]
            ? res.data[event].map((r) => ethers_1.ethers.utils.parseEther(r.amount))
            : [];
    }
    async getTtBalanceForRewardsDiff(block) {
        // TODO: encapsulate in smart contract function
        const stakingBalance = await this.provider.getBalance(this.staking.address, block);
        const bidVaultBalance = await this.provider.getBalance(await this.staking.bidVault(), block);
        const vaultAvailableBalance = await this.staking.getAvailableBalance({
            blockTag: block,
        });
        // const leave = await this.staking.getUnstaking();
        return stakingBalance.add(bidVaultBalance).add(vaultAvailableBalance);
    }
    static async annualReturnDividedByStakingScore(reward, totalStakingScore, sessionInYear) {
        debug("reward:", ethers_1.ethers.utils.formatEther(reward));
        debug("totalStakingScore:", ethers_1.ethers.utils.formatEther(totalStakingScore));
        debug("sessionInYear:", sessionInYear);
        const sessionReturn = 1 +
            parseFloat(ethers_1.ethers.utils.formatEther(reward)) /
                parseFloat(ethers_1.ethers.utils.formatEther(totalStakingScore));
        debug("sessionReturn:", sessionReturn);
        const compounded = Math.pow(sessionReturn, sessionInYear) - 1;
        return compounded;
    }
    // sessionPerYear = 8 sessions per day * 365 days per year
    //    (1 session ~= 3 hours, so there are ~ 8 sessions in 24 hours)
    // APY = (1 + (lastReward/totalStakingScore)) ^ sessionPerYear - 1
    async getApyFromSessionDiff(blockNumber) {
        if (!blockNumber) {
            blockNumber = await this.provider.getBlockNumber();
        }
        const session = await StakingHelper.getSNByBlock(blockNumber, this.rpc);
        debug("session", session);
        const block = await this.getBlock(blockNumber);
        const sessionStartBlock = blockNumber - (parseInt(block.nonce, 16) - 1); // nonce starts from 1
        const balance = await this.getTtBalanceForRewardsDiff(sessionStartBlock);
        if (session === 0 || balance.eq(ethers_1.ethers.BigNumber.from(0))) {
            return 0;
        }
        // Query for `enter` and `withdraw` but not `leave` since the latter does not affect contract TT balance
        const queryResult = await this.queryEnterAndWithdrawTtAmountsBySession(session - 1);
        // {
        //   "enters": [
        //     {
        //       "ttAmount": "10000"
        //     }
        //   ],
        //   "withdraws": [
        //     {
        //       "ttAmount": "20053841867083950718468"
        //     }
        //   ]
        // }
        debug("queryEnterAndLeaveTtAmountsBySession:", queryResult);
        const enters = queryResult["enters"].map((o) => o["ttAmount"]);
        const leaves = queryResult["withdraws"].map((o) => o["ttAmount"]);
        // Block number of stopBlock plus two consecutive normal blocks
        const sessionBlocks = this.stopBlockSessionOffset + 2;
        const sessionInYear = (365.25 * 24 * 60 * 60) / this.blockTime / sessionBlocks;
        const lastSessionBalance = await this.getTtBalanceForRewardsDiff(sessionStartBlock - sessionBlocks);
        const [manualRewards, lastReward] = await Promise.all([
            this.getManuallyAddedRewards(session),
            this.getLastRewardFromSessionDiff({
                lastBalance: lastSessionBalance,
                currentBalance: balance,
                stakes: enters,
                withdraws: leaves,
                sessionStartBlock,
            }),
        ]);
        const totalStakingScore = await this.getTotalStakingScore(blockNumber);
        const rewards = lastReward.add(manualRewards);
        return StakingHelper.annualReturnDividedByStakingScore(rewards, totalStakingScore, sessionInYear);
    }
    async queryEnterAndWithdrawTtAmountsBySession(session) {
        const query = `query EntersAndLeavesTtAmountBySession($session: Int!) {
      enters(where: {session: $session}) {
        ttAmount
      }
      withdraws(where: {session: $session}) {
        ttAmount
      }
    }`;
        const variables = { session };
        return StakingHelper.graphqlQuery(this.pos2SubgraphUrl, query, variables);
    }
    async queryRewardAddsBySession(session) {
        const query = `query RewardAddsBySession($session: Int!) {
      rewardAdds(where: {session: $session}) {
        ttAmount
      }
    }`;
        const variables = { session };
        return StakingHelper.graphqlQuery(this.pos2SubgraphUrl, query, variables);
    }
    async getApyFromSessionDiffOldSubgraph(posSubgraphUrl, blockNumber) {
        let session = 0;
        if (!blockNumber) {
            blockNumber = await this.provider.getBlockNumber();
            session = await this.getSession();
        }
        else {
            session = await StakingHelper.getSNByBlock(blockNumber, this.rpc);
        }
        debug("session", session);
        const block = await this.getBlock(blockNumber);
        const sessionStartBlock = blockNumber - (parseInt(block.nonce, 16) - 1); // nonce starts from 1
        const balance = await this.getTtBalanceForRewardsDiff(sessionStartBlock);
        if (session === 0 || balance.eq(ethers_1.ethers.BigNumber.from(0))) {
            return 0;
        }
        // debug("pre getLastSessionAmts: stakes");
        // debug("pre getLastSessionAmts: withdraws");
        const [stakes, withdraws] = await Promise.all([
            StakingHelper.getLastSessionAmts(posSubgraphUrl, "stakes", session),
            StakingHelper.getLastSessionAmts(posSubgraphUrl, "withdraws", session),
        ]);
        // Block number of stopBlock plus two consecutive normal blocks
        const sessionBlocks = this.stopBlockSessionOffset + 2;
        const sessionInYear = (365.25 * 24 * 60 * 60) / this.blockTime / sessionBlocks;
        // debug("pre getTtBalanceForAll");
        const lastSessionBalance = await this.getTtBalanceForRewardsDiff(sessionStartBlock - sessionBlocks);
        const lastReward = await this.getLastRewardFromSessionDiff({
            lastBalance: lastSessionBalance,
            currentBalance: balance,
            stakes,
            withdraws,
            sessionStartBlock,
        });
        const totalStakingScore = await this.getTotalStakingScore(blockNumber);
        return StakingHelper.annualReturnDividedByStakingScore(lastReward, totalStakingScore, sessionInYear);
    }
    // sessionPerYear = 8 sessions per day * 365 days per year
    //    (1 session ~= 3 hours, so there are ~ 8 sessions in 24 hours)
    // APY = (1 + (lastReward/totalStakingScore)) ^ sessionPerYear - 1
    async getAPY(blockNumber) {
        if (!blockNumber) {
            blockNumber = await this.provider.getBlockNumber();
        }
        debug("blockNumber", blockNumber);
        const block = await this.getBlock(blockNumber);
        const sessionStartBlock = blockNumber - (parseInt(block.nonce, 16) - 1); // nonce starts from 1
        // For almost all sessions, `sessionStartBlock -2` is the stop block with the reward info
        // This is from PaLa's "two consecutive normal blocks" requirement.
        //
        // To handle situations where the immediate blocks after the stop block are not two consecutive normal blocks,
        // use `stopBlockSessionOffset` from the start of the session
        const prevSessionEndBlockNumber = sessionStartBlock - 1;
        const prevSessionBlock = await this.getBlock(prevSessionEndBlockNumber);
        const prevSessionStartBlockNumber = prevSessionEndBlockNumber - (parseInt(prevSessionBlock.nonce, 16) - 1); // nonce starts from 1
        const stopBlockNumber = prevSessionStartBlockNumber + this.stopBlockSessionOffset - 1;
        const rewardBlockNumber = stopBlockNumber;
        debug("rewardBlockNumber", rewardBlockNumber);
        let compounded;
        try {
            const session = await StakingHelper.getSNByBlock(blockNumber, this.rpc);
            const [manualRewards, lastReward, totalStakingScore] = await Promise.all([
                this.getManuallyAddedRewards(session),
                StakingHelper.getConsensusRewards(rewardBlockNumber, this.rpc, this.staking.address),
                this.getTotalStakingScore(blockNumber),
            ]);
            const rewards = lastReward.add(manualRewards);
            debug("manualRewards:", ethers_1.ethers.utils.formatEther(manualRewards));
            debug("lastReward:", ethers_1.ethers.utils.formatEther(lastReward));
            debug("totalStakingScore:", ethers_1.ethers.utils.formatEther(totalStakingScore));
            debug("rewards", ethers_1.ethers.utils.formatEther(rewards));
            // Block number of stopBlock plus two consecutive normal blocks
            const sessionBlocks = this.stopBlockSessionOffset + 2;
            const sessionInYear = (365.25 * 24 * 60 * 60) / this.blockTime / sessionBlocks;
            return StakingHelper.annualReturnDividedByStakingScore(rewards, totalStakingScore, sessionInYear);
        }
        catch (e) {
            debug("error:", e);
            return this.getApyFromSessionDiff(blockNumber);
        }
    }
    async getVeTTExchangeRate() {
        const [totalTt, veTotalSupply] = await Promise.all([
            this.staking.getTTPool(),
            this.staking.totalSupply(),
        ]);
        const rate = totalTt.mul(ether).div(veTotalSupply);
        return rate;
    }
    async getAccountVeTTTokenEvents(posSubgraphUrl, account) {
        const floatSum = (arr) => {
            return arr.reduce((a, b) => a + parseFloat(b), 0);
        };
        const setupQueries = (account) => {
            const queries = {
                stakes: {
                    query: `{ stakes(where: {account: "${account}"}) { amount } }`,
                    parseKey: "amount",
                },
                burns: {
                    query: `{ burns(where: {account: "${account}"}) { ttAmount amount } }`,
                    parseKey: "ttAmount",
                },
                transferOut: {
                    query: `{ transfereds(where: {from: "${account}"}) { tt } }`,
                    parseKey: "tt",
                },
                transferIn: {
                    query: `{ transfereds(where: {to: "${account}"}) { tt } }`,
                    parseKey: "tt",
                },
            };
            return async (event) => {
                return {
                    res: await StakingHelper.graphqlQuery(posSubgraphUrl, queries[event].query, {}),
                    event,
                    parseKey: queries[event].parseKey,
                };
            };
        };
        const getQuery = setupQueries(account);
        const res = await Promise.all([getQuery("stakes"), getQuery("burns")]);
        const [stakes, burns] = res.map((r) => {
            const data = r.res[r.event];
            return floatSum(data.map((d) => d[r.parseKey]));
        });
        // transfers
        // function getTransferAmounts(result: any) {
        //   const { res } = result;
        //   const amountStr = res.transfereds.map((data: { tt: string }) => {
        //     return data.tt.startsWith("-") ? data.tt.slice(1) : data.tt;
        //   }) as string[];
        //   return floatSum(amountStr);
        // }
        // const transferIns = getTransferAmounts(await getQuery("transferIn"));
        // const transferOuts = getTransferAmounts(await getQuery("transferOut"));
        // const transfers = transferOuts - transferIns;
        // console.log("transferIns:", transferIns);
        // console.log("transferOuts:", transferOuts);
        // console.log("transfers:", transfers);
        return { stakes, burns, transfers: 0 };
    }
    async queryEnterAndLeaveTtAmountsByWallet(wallet) {
        const query = `query EntersAndLeavesTtAmountByWallet($wallet: Bytes!) {
      enters(where: {wallet: $wallet}) {
        ttAmount
      }
      leaves(where: {wallet: $wallet}) {
        ttAmount
      }
    }`;
        const variables = { wallet };
        return StakingHelper.graphqlQuery(this.pos2SubgraphUrl, query, variables);
    }
    async getWalletRewardsEarned(wallet) {
        // TODO: separate data fetching and calculations
        //
        // queryResult
        // {
        //   "enters": [
        //     {
        //       "ttAmount": "88400000000000000000000"
        //     },
        //   ],
        //   "leaves": [
        //     {
        //       "ttAmount": "128502254818702245777"
        //     },
        // }
        const [walletVeTt, poolTt, veTtTotalSupply, queryResult] = await Promise.all([
            this.staking.balanceOf(wallet),
            this.staking.getTTPool(),
            this.staking.totalSupply(),
            this.queryEnterAndLeaveTtAmountsByWallet(wallet),
        ]);
        const walletTt = walletVeTt.mul(poolTt).div(veTtTotalSupply);
        const enters = sumAttributeBigNumbers(queryResult["enters"], "ttAmount");
        const leaves = sumAttributeBigNumbers(queryResult["leaves"], "ttAmount");
        let earned = walletTt.add(leaves).sub(enters);
        if (earned.lt(ethers_1.BigNumber.from(0))) {
            earned = ethers_1.BigNumber.from(0);
        }
        return earned;
    }
    async getAccountStakedInfo(posSubgraphUrl, inputAccount) {
        try {
            const account = inputAccount.toLowerCase();
            const { stakes, burns, transfers } = await this.getAccountVeTTTokenEvents(posSubgraphUrl, account);
            const userVeTT = await this.staking.balanceOf(account);
            const rate = await this.getVeTTExchangeRate();
            const userTT = parseFloat(ethers_1.ethers.utils.formatEther(userVeTT.mul(rate).div(ether))); // decimals truncated
            let earned = userTT + burns - stakes + transfers;
            if (earned < 0)
                earned = 0;
            return {
                stakes,
                burns,
                earned,
                userTT,
            };
        }
        catch (error) {
            console.log("error:", error);
            return {
                stakes: 0,
                burns: 0,
                earned: 0,
                userTT: 0,
            };
        }
    }
    async getTokenHolders(contractAddr) {
        // Use BlockScout API
        const queryParams = `?module=token&action=getTokenHolders&contractaddress=${contractAddr}`;
        const url = this.blockscoutApiUrl + queryParams;
        const res = await (0, cross_fetch_1.default)(url);
        const resJson = await res.json();
        return resJson;
    }
}
exports.StakingHelper = StakingHelper;
